var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLightIllustration(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 103,
    height: 68,
    viewBox: "0 0 103 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 103,
    height: 68,
    rx: 5,
    fill: "#EFEFEF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 17,
    width: 18,
    height: 45,
    fill: "#C4C4C4"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 6,
    width: 91,
    height: 8,
    fill: "#C4C4C4"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 35,
    width: 68,
    height: 27,
    fill: "#C4C4C4"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 18,
    width: 13,
    height: 13,
    fill: "#FAD9A9"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 18,
    width: 13,
    height: 13,
    fill: "#B7E4B6"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 65,
    y: 18,
    width: 13,
    height: 13,
    fill: "#B4E5F0"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 83,
    y: 18,
    width: 13,
    height: 13,
    fill: "#E0A1A1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightIllustration);
export default __webpack_public_path__ + "static/media/light-illustration.6c373cbb10a9e0737d2282a53df0584b.svg";
export { ForwardRef as ReactComponent };